// src/components/Agent/AgentMode.jsx
import { useState, useRef } from 'react';
import { Send, Square } from 'lucide-react';
import { startAgentRun, approveAgentRun } from '../../services/agentService';
import './agent.css';

export default function AgentMode() {
  const [goal, setGoal] = useState('');
  const [steps, setSteps] = useState([]);
  const [running, setRunning] = useState(false);
  const [runId, setRunId] = useState(null);
  const abortRef = useRef(null);

  const run = () => {
    if (!goal.trim() || running) return;
    setSteps([]); setRunning(true);
    abortRef.current = startAgentRun(goal.trim(), {
      onStep: (s) => setSteps((p) => [...p, s]),
      onRun: (r) => setRunId(r.run_id),
      onDone: () => setRunning(false),
      onError: () => setRunning(false),
    });
  };
  const stop = () => { abortRef.current?.(); setRunning(false); };

  const awaitingApproval = steps.length > 0 && steps[steps.length - 1].type === 'approval_request';

  const decide = (decision) => {
    if (!runId) return;
    setRunning(true);
    abortRef.current = approveAgentRun(runId, decision, {
      onStep: (s) => setSteps((p) => [...p, s]),
      onDone: () => setRunning(false),
      onError: () => setRunning(false),
    });
  };

  return (
    <div className="agent-wrap">
      <div className="agent-steps">
        {steps.map((s, i) => (
          <div key={i} className={`agent-step agent-step--${s.type}`}>
            <span className="agent-step-type">{s.type}</span>
            <span className="agent-step-body">
              {s.type === 'tool_call' ? `${s.tool}(${JSON.stringify(s.args)})`
                : s.type === 'observation' ? JSON.stringify(s.observation)
                : s.content || ''}
            </span>
          </div>
        ))}
      </div>
      {awaitingApproval && !running && (
        <div className="agent-approval">
          <span className="agent-approval-text">
            Approve action: {steps[steps.length - 1].tool}({JSON.stringify(steps[steps.length - 1].args)})?
          </span>
          <button className="vault-btn vault-btn--primary" onClick={() => decide('approve')}>Approve</button>
          <button className="vault-btn vault-btn--danger" onClick={() => decide('deny')}>Deny</button>
        </div>
      )}
      <div className="agent-composer">
        <input className="vault-field" placeholder="Give the agent a goal..."
          value={goal} onChange={(e) => setGoal(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && run()} disabled={running} />
        {running
          ? <button className="vault-btn vault-btn--danger" onClick={stop}><Square />Stop</button>
          : <button className="vault-btn vault-btn--primary" onClick={run}><Send />Run</button>}
      </div>
    </div>
  );
}
